/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__invitation__model__SortByColumnEnum;

(function (jove__app__invitation__model__SortByColumnEnum) {
  jove__app__invitation__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__invitation__model__SortByColumnEnum["CONTRACT_ID"] = "contract_id";
})(jove__app__invitation__model__SortByColumnEnum || (jove__app__invitation__model__SortByColumnEnum = {}));